import { Routes } from '@angular/router';

import { Empty } from './empty/empty';
import { Dashboard } from './dashboard/dashboard.component';
import { AppLayout } from '../layout/component/app.layout';
import { SectionsComponent } from './sections/sections.component';
import { authGuard, contextResolver } from '../core';
import { UserProfileComponent } from '../layout/component/user-profile/user-profile.component';
import { maintenanceGuard } from '../core/guard/maintenance.guard';
import { MaintenanceModeComponent } from './maintenance-mode/maintenance-mode.component';

export const pagesRoutes: Routes = [
    {
        path: 'maintenance-mode',
        component: MaintenanceModeComponent,
    },
    {
        path: '',
        component: AppLayout,
        canActivate: [maintenanceGuard],
        children: [
            { path: '', redirectTo: 'sections', pathMatch: 'full' },
            { 
                path: 'sections',
                component: SectionsComponent,
                canActivate: [authGuard],
                
            },
            {
                path: 'cass',
                loadChildren: () => import('./systems/cass/cass.routes'),
                canActivate: [authGuard],
                resolve: {
                    context: contextResolver
                },
                data: { module: 'cass', sistemaId: 1 }
            },
            {
                path: 'mantenimiento',
                loadChildren: () => import('./systems/mantenimiento/mantenimiento.routes'),
                canActivate: [authGuard],
                resolve: {
                    context: contextResolver
                },
                data: { module: 'mantenimiento', sistemaId: 2 }
            },
            {
                path: 'administracion',
                loadChildren: () => import('./systems/administracion/administracion.routes'),
                canActivate: [authGuard],
                resolve: {
                    context: contextResolver
                },
                data: { module: 'administracion', sistemaId: 3 }
            },
            {
                path: 'calidad',
                loadChildren: () => import('./systems/calidad/calidad.routes'),
                canActivate: [authGuard],
                resolve: {
                    context: contextResolver
                },
                data: { module: 'calidad', sistemaId: 4 }
            },
            {
                path: 'tickets',
                loadChildren: () => import('./tickets/tickets.routes').then(m => m.ticketsRoutes),
                canActivate: [authGuard],
                data: { title: 'Tickets' }
            },
            {
                path: 'ayuda',
                loadComponent: () => import('./ayuda/ayuda.component').then(m => m.AyudaComponent),
                canActivate: [authGuard],
                data: { title: 'Ayuda' }
            },
            {
                path: 'notificaciones',
                loadComponent: () => import('./notificaciones/notificaciones.component').then(m => m.NotificacionesComponent),
                canActivate: [authGuard],
                data: { title: 'Notificaciones' }
            },
            {
                path: 'perfil',
                component: UserProfileComponent,
                canActivate: [authGuard],
                data: { module: 'perfil' }
            },
            {
                path: '404',
                loadComponent: () => import('./notfound/notfound').then(m => m.Notfound),
                canActivate: [authGuard],
                data: { title: 'Página no encontrada' }
            },
            // Fallback para rutas no encontradas dentro del layout
            {
                path: '**',
                redirectTo: '404'
            }
            
        ]
    }
];
